import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { filterParams } from "core/util/ParamUtil";
import { Entry } from "./Entry";

@Entity({
	one: "organization",
	params: filterParams(['guid'])
})
export class Organization {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field({
		entity: Entry,
		params: filterParams(['pageSize', 'query', 'sort'])
	})
	public entryList?: Entry[];

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/OrganizationEntries.ts